import axios from 'axios';
import Endpoints from '../Endpoints';

export const getLobbySettings = async () => {
    const { data } = await axios.get(Endpoints.Lobby.GET);
    return data.data;
};

export const updateLobbySettings = async (payload) => {
    const { data } = await axios.put(Endpoints.Lobby.UPDATE, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }
    });
    return data.data;
};
